
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke142aRequest, Sgke142aResponse, Sgke142aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke142aService {

  /**
   * コンストラクタ
   * @param {Sgke142aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke142aService
   */
  constructor(
    public service: Sgke142aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE142A_手数料報告初期表示（入金突合）API呼び出し
   * @param {Sgke142aRequest} request 
   * @returns {Observable<Sgke142aResponse>}
   * @memberof UsedSgke142aService
   */
  public doSgke142a(request: Sgke142aRequest): Observable<Sgke142aResponse> {
    return this.service.sgke142aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE142A');
          return throwError(err.message);
        })
      );
  }

}
